<template>
    <div>
        <v-main>
            <user_questions_list @updateView="updateView" :wInnerHeight="wInnerHeight" v-if="oavr_nr===0"/>
            <user_question_details @updateView="updateView" :oavr_nr="oavr_nr" v-if="oavr_nr!==0"/>
        </v-main>
        <navBar title="Ares - Customer Success" :home="true" type="customersuccess" goto="/task/customer_success/mnCustomerSuccess" />
    </div>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";
    import user_questions_list from '@/components/task/customer_success/openai/user_questions_list.vue'
    import user_question_details from '@/components/task/customer_success/openai/user_question_details.vue'

    export default {
        components: {
            navBar,
            user_questions_list,
            user_question_details,
        },    
        data() {
            return {
                oavr_nr: 0,
                wInnerHeight: 0, 
            }
        },    
        created() { // set up event bus listener here on created event or get data
            window.addEventListener("resize", this.resizeEventHandler);
        },
        destroyed() {
            window.removeEventListener("resize", this.resizeEventHandler);
        },
        mounted() {
            this.resizeEventHandler();
        },
        methods: {     
            resizeEventHandler() {
                this.wInnerHeight = window.innerHeight - 250; // deduct estimated height for toolbar, searchfield and headers
            },
            updateView(oavr_nr) {
                this.oavr_nr = oavr_nr;
            }
        }
    }
</script>

<style scoped> 

</style>